import { SET_USER } from "../actions/types";

const initialUser = {
  currentUser: null,
  isLoading: true,
};

//Handling User
export const userReducer = (state = initialUser, { type, payload }) => {
  switch (type) {
    case SET_USER:
      return {
        currentUser: payload.currentUser,
        isLoading: false,
      };

    default:
      return state;
  }
};
